import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { setBanId, setBanError, selectUserById } from "src/store/community/usersSlice";
import { fetchUser, blockUser } from "src/actions/community/usersActions";
import { objToFormData } from "src/helpers/FormHelper";

import { AudioOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { Button as ButtonAnt } from "antd";
import DrawerRight from "src/componets/DrawerRight";
import AlertBlock from "src/componets/AlertBlock";
import FormBlock from "./_partials/_FormBlock";
import Meta from "./_partials/_Meta";
import RowInfo from "src/componets/RowInfo";
import { formattedDate } from "src/helpers/DateHelpers";
import { Button } from "src/componets/Buttons";

const Block = () => {
  const dispatch = useAppDispatch();
  const id: any = useAppSelector(state => state.community.users.banId);
  const error = useAppSelector(state => state.community.users.banError);
  const user = useAppSelector(state => selectUserById(state, id));

  useEffect(() => {
    if (id) {
      dispatch(fetchUser(id));
    }
  }, [id, dispatch]);

  function onCloseError() {
    dispatch(setBanError(null));
  }

  function onClose() {
    dispatch(setBanId(null));
  }

  function onClickUnBlock(type: 'ban' | 'mute') {
    handleSave({ type: type, period: 0, duration: 'days' }).catch(console.error);
  }

  function onFinish(data: any) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: any) {
    const formData = objToFormData(data);
    dispatch(blockUser({ id, data: formData }));
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-user'>
        <h6 className="v-content-label">Block User</h6>

        <div className='v-mb-20'>{<Meta user={user} />}</div>

        <div className='v-mb-20'>
          {
            user?.muted &&
              <RowInfo
                  left={
                    <>
                      Muted Until: <u>{formattedDate(user?.muted_until).dateTime}</u>
                    </>
                  }
                  right={<Button onClick={() => onClickUnBlock('mute')} title='Remove Mute' icon={AudioOutlined} />}
              />
          }
          {
            user?.banned &&
              <RowInfo
                left={
                  <>
                    Banned Until: <u>{formattedDate(user?.banned_until).dateTime}</u>
                  </>
                }
                right={<Button onClick={() => onClickUnBlock('ban')} title='Remove Ban' icon={CheckCircleOutlined} />}
              />
          }
        </div>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <FormBlock params={{ period: 5, duration: 'minutes', type: 'mute' }} onFinish={onFinish} />
        <FormBlock params={{ period: 1, duration: 'days', type: 'ban' }} onFinish={onFinish} />

        <ButtonAnt className="v-btn v-btn-primary" onClick={onClose} style={{ width: '100%' }}>
          Close
        </ButtonAnt>
      </div>
    </DrawerRight>
  )
}

export default Block;
